<template>
  <modal
    name="new-transfer-modal"
    width="600"
    height="auto"
    :adaptive="true"
    :scrollable="true"
  >
    <div class="py-6">
      <h2 class="text-xl font-bold mb-4 px-6">Yeni Transfer</h2>

      <div v-if="inventory" class="mb-4 mx-6 p-3 bg-gray-100 rounded">
        <p class="text-sm text-gray-600">Transfer Edilecek Ürün:</p>
        <p class="font-bold">{{ inventory.name }}</p>
        <p class="text-sm text-gray-600">Mevcut Konum: {{ getLocationLabel(inventory.current_location) }}</p>
      </div>

      <form @submit.prevent="save" class="px-6">
        <div class="grid grid-cols-1 gap-4">

          <!-- Hedef Konum Tipi -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Hedef Konum <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.destination_type"
              required
              @change="onDestinationTypeChange"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seçiniz</option>
              <option value="ARAC">Araç</option>
              <option value="SUBE">Şube</option>
              <option value="BOSTA">Boşta</option>
            </select>
          </div>

          <!-- Araç Seçimi (Eğer hedef ARAC ise) -->
          <div v-if="form.destination_type === 'ARAC'" class="w-full -px-8 mt-2">
            <diffInput
              title="Hedef Araç"
              v-model="form.destination_id"
              required
              type="select"
              :optList="vehicleOptions"
              placeholder="Araç Seçiniz"
            />
            <div v-if="loadingVehicles" class="text-xs text-gray-500 mt-1">
              <i class="fas fa-spinner fa-spin mr-1"></i> Araçlar yükleniyor...
            </div>
          </div>

          <!-- Şube Seçimi (Eğer hedef SUBE ise) -->
          <div v-if="form.destination_type === 'SUBE'" class="w-full -px-8 mt-2">
            <diffInput
              title="Hedef Şube"
              v-model="form.destination_id"
              required
              type="select"
              :optList="branchOptions"
              placeholder="Şube Seçiniz"
            />
            <div v-if="loadingBranches" class="text-xs text-gray-500 mt-1">
              <i class="fas fa-spinner fa-spin mr-1"></i> Şubeler yükleniyor...
            </div>
          </div>

          <!-- Transfer Nedeni -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Transfer Nedeni <span class="text-red-500">*</span>
            </label>
            <select
              v-model="form.reason"
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seçiniz</option>
              <option value="Operasyonel İhtiyaç">Operasyonel İhtiyaç</option>
              <option value="Bakım">Bakım</option>
              <option value="Arıza">Arıza</option>
              <option value="Stok Düzenleme">Stok Düzenleme</option>
              <option value="Müşteri Talebi">Müşteri Talebi</option>
              <option value="Diğer">Diğer</option>
            </select>
          </div>

          <!-- Notlar -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Notlar
            </label>
            <textarea
              v-model="form.notes"
              rows="3"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
              placeholder="Transfer hakkında ek bilgiler"
            ></textarea>
          </div>

        </div>

        <!-- Butonlar -->
        <div class="flex justify-end space-x-3 mt-6">
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            İptal
          </button>
          <button
            type="submit"
            :disabled="loading"
            class="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-green-400"
          >
            <span v-if="loading">Transfer Ediliyor...</span>
            <span v-else>Transfer Et</span>
          </button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import axios from 'axios';
import { inventory, branches } from '../../../../networking/urlmanager';
import { getLocationAll } from '../../../../utils/detailData';
import diffInput from '@/components/general/diffInput.vue';

export default {
  name: 'NewTransferModal',
  components: {
    diffInput
  },
  props: {
    inventory: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      loadingVehicles: false,
      loadingBranches: false,
      vehicles: [],
      branches: [],
      form: {
        destination_type: '',
        destination_id: null,
        reason: '',
        notes: ''
      }
    };
  },
  created(){
    this.getVehicles();
    this.getBranches();
    this.resetForm();
  },
  computed: {
    vehicleOptions() {
      return this.vehicles.map(vehicle => ({
        id: vehicle.id,
        name: `${vehicle.plate} ${vehicle.driverName ? '- ' + vehicle.driverName : '- Sürücü Atanmamış'}`
      }));
    },
    branchOptions() {
      return this.branches.map(branch => ({
        id: branch.id,
        name: branch.name
      }));
    }
  },
  methods: {
    async getVehicles() {
      this.loadingVehicles = true;
      try {
        // detailData.js'den getLocationAll fonksiyonunu kullan
        const vehicleData = await getLocationAll(this.$store.state.userData.token);

        if (vehicleData && vehicleData.length > 0) {
          // Araçları plaka ismine göre sırala
          this.vehicles = vehicleData
            .sort((a, b) => {
              return (a.name || '').localeCompare(b.name || '');
            });
          console.log('Yüklenen araç sayısı:', this.vehicles.length);
        } else {
          console.log('Araç verisi bulunamadı');
          this.vehicles = [];
        }
      } catch (error) {
        console.error('Error fetching vehicles:', error);
        this.vehicles = [];
      } finally {
        this.loadingVehicles = false;
      }
    },

    async getBranches() {
      this.loadingBranches = true;
      try {
        const response = await axios.get(branches.getNotPagination, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          }
        });

        if (response.data.code === 200) {
          this.branches = response.data.data || [];
          console.log('Yüklenen şube sayısı:', this.branches.length);
        } else {
          console.log('Şube verisi bulunamadı');
          this.branches = [];
        }
      } catch (error) {
        console.error('Error fetching branches:', error);
        this.branches = [];
      } finally {
        this.loadingBranches = false;
      }
    },

    onDestinationTypeChange() {
      // Reset destination_id when type changes
      if (this.form.destination_type !== 'ARAC' && this.form.destination_type !== 'SUBE') {
        this.form.destination_id = null;
      }
    },

    async save() {
      if (!this.form.destination_type || !this.form.reason) {
        this.$toast.error('Lütfen zorunlu alanları doldurun');
        return;
      }

      if (this.form.destination_type === 'ARAC' && !this.form.destination_id) {
        this.$toast.error('Lütfen hedef araç seçiniz');
        return;
      }

      if (this.form.destination_type === 'SUBE' && !this.form.destination_id) {
        this.$toast.error('Lütfen hedef şube seçiniz');
        return;
      }

      this.loading = true;
      try {
        // Eğer araç seçildiyse, plaka bilgisini bul
        let destinationPlate = null;
        if (this.form.destination_type === 'ARAC' && this.form.destination_id) {
          const selectedVehicle = this.vehicles.find(v => v.id === this.form.destination_id);
          destinationPlate = selectedVehicle ? selectedVehicle.plate : null;
        }

        // Eğer şube seçildiyse, şube adını bul
        if (this.form.destination_type === 'SUBE' && this.form.destination_id) {
          const selectedBranch = this.branches.find(b => b.id === this.form.destination_id);
          destinationPlate = selectedBranch ? selectedBranch.name : null;
        }

        const payload = {
          inventory_id: this.inventory.id,
          source_type: this.mapLocationType(this.inventory.current_location),
          source_id: this.inventory.location_id,
          destination_type: this.form.destination_type,
          destination_id: this.form.destination_id,
          destination_plate: destinationPlate, // Plaka bilgisi eklendi
          reason: this.form.reason,
          notes: this.form.notes
        };

        const response = await axios.post(inventory.transfer, payload, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          }
        });

        if (response.data.code === 200) {
          this.$toast.success('Transfer işlemi başarıyla tamamlandı');
          this.resetForm();
          this.closeModal();
          this.$emit('refresh');
        }
      } catch (error) {
        console.error('Error transferring inventory:', error);
        this.$toast.error(error.response?.data?.message || 'Transfer işlemi başarısız');
      } finally {
        this.loading = false;
      }
    },

    mapLocationType(location) {
      const mapping = {
        'BOSTA': 'BOSTA',
        'ARACTA': 'ARAC',
        'GARAJDA': 'SUBE',
        'SUBEDE': 'SUBE',
        'TRANSFERDE': 'DIGER'
      };
      return mapping[location] || 'DIGER';
    },

    getLocationLabel(location) {
      const labels = {
        'BOSTA': 'Boşta',
        'ARACTA': 'Araçta',
        'GARAJDA': 'Şubede',
        'SUBEDE': 'Şubede',
        'TRANSFERDE': 'Transferde'
      };
      return labels[location] || location;
    },

    resetForm() {
      this.form = {
        destination_type: '',
        destination_id: null,
        reason: '',
        notes: ''
      };
    },

    closeModal() {
      this.$modal.hide('new-transfer-modal');
      this.resetForm();
    }
  }
};
</script>
